const endPoint = process.env.REACT_APP_backend || "http://localhost:1555";
console.log(process.env.REACT_APP_backend);

export async function getLanguagePairs() {
    const response = await fetch(endPoint + "/languagePairs" );
    return response.json();
}